import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadAppBannerComponent } from './components/download-app-banner/download-app-banner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { DownloadAppBannerComponentV3 } from './components/download-app-banner-v3/download-app-banner-v3.component';

@NgModule({
  declarations: [
    DownloadAppBannerComponent,
    DownloadAppBannerComponentV3
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule
  ],
  exports: [
    DownloadAppBannerComponent,
    DownloadAppBannerComponentV3
  ],
  bootstrap: [DownloadAppBannerComponent]
})
export class DownloadAppBannerModule {
  getComponent() {
    return DownloadAppBannerComponent;
  }
}
